// Famous reviews modal, users reviews modal
(function () {
    const initFamousReviewModal = (item) => {
        const moreLink = item.querySelector(`.js-review-more-link`);

        moreLink?.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            const title = item.querySelector(`.review-item__name`);
            const description = item.querySelector(`.review-item__full-description`);
            const text = item.querySelector(`.review-item__full-text`);

            let titleContent = ``;
            let descriptionContent = ``;
            let textContent = ``;

            if (title) {
                titleContent = `<h3 class="review-item__name">${title.textContent}</h3>`;
            }
            if (description) {
                descriptionContent = `<p class="review-item__description">${description.innerHTML}</p>`;
            }
            if (text) {
                textContent = `<div class="review-item__body">${text.innerHTML}</div>`;
            }

            const modalHeading = `<div class="review-item__heading">${titleContent + descriptionContent}</div>`;
            const modalContent = modalHeading + textContent;

            Swal.fire({
                customClass: {
                    container: `modal modal--review`,
                    popup: `modal__popup`,
                },
                html: modalContent,
                showCloseButton: true,
                showConfirmButton: false,
                returnFocus: false,
            });
        });
    };

    const initUsersReviewModal = (item) => {
        const moreLink = item.querySelector(`.js-full-user-review`);

        moreLink?.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            const title = item.querySelector(`.review-card__author-name`);
            const text = item.querySelector(`.review-card__text-full`);

            let titleContent = ``;
            let textContent = ``;

            if (title) {
                titleContent = `<h3 class="review-card__author-name">${title.textContent}</h3>`;
            }
            if (text) {
                textContent = `<div class="review-card__bottom">${text.innerHTML}</div>`;
            }

            const modalHeading = `<div class="review-card__heading">${titleContent}</div>`;
            const modalContent = modalHeading + textContent;


            Swal.fire({
                customClass: {
                    container: `modal modal--review`,
                    popup: `modal__popup`,
                },
                html: modalContent,
                showCloseButton: true,
                showConfirmButton: false,
                returnFocus: false,
            });
        });
    };

    window.modal = {
        initUsersReviewModal: initUsersReviewModal,
        initFamousReviewModal: initFamousReviewModal,
    };
})();

// Feedback modal
(function () {
    const triggerButtons = document.querySelectorAll(`.js-open-feedback-modal`);
    const feedbackModal = document.querySelector(`.feedback-modal--message`);

    if (feedbackModal) {
        const feedbackModalContent = feedbackModal.innerHTML;

        triggerButtons.forEach((button) => {
            button.addEventListener(`click`, (evt) => {
                evt.preventDefault();

                Swal.fire({
                    customClass: {
                        container: `modal modal--feedback`,
                        htmlContainer: `feedback-modal`,
                        popup: `modal__popup`,
                    },
                    html: feedbackModalContent,
                    showCloseButton: true,
                    showConfirmButton: false,
                    returnFocus: false,
                });

                const feedbackModalSweetAlert = document.querySelector(`.modal--feedback`);

                if (feedbackModalSweetAlert) {
                    const phoneInput = feedbackModalSweetAlert.querySelector(`.form__input--phone`);
                    const phoneMask = window.form.setPhoneMask(phoneInput);

                    const formFields = feedbackModalSweetAlert.querySelectorAll(`.form__field`);
                    formFields.forEach((field) => {
                        window.form.initLabel(field);
                    });
                    const form = feedbackModalSweetAlert.querySelector(`.feedback-modal__form`);
                    form?.addEventListener(`submit`, (evt) => {
                        evt.preventDefault();

                        if (phoneMask.unmaskedValue.length < 11) return;

                        if (!lockForm(form)) return;
                        feedbackModalSweetAlert.classList.add(`modal--pending`);

                        let formData = new FormData(form);

                        fetch('/include/ajax/product_form_consultation.php', {
                            method: 'POST',
                            body: formData
                        })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                }
                                return response.json();
                            })
                            .then((result) => {
                                if (!result.success) {
                                    throw new Error(result.message);
                                }
                                feedbackModalSweetAlert.classList.remove(`modal--pending`);
                                feedbackModalSweetAlert.classList.add(`modal--response-success`);
                                unlockForm(form);
                            })
                            .catch((error) => {
                                feedbackModalSweetAlert.classList.remove(`modal--pending`);
                                alert(error.message);
                                unlockForm(form);
                            });
                    });
                }
            });
        });
    }
})();

// Discount modal
(function () {
    const triggerButtons = document.querySelectorAll(`.js-open-discount-modal`);
    const feedbackModal = document.querySelector(`.feedback-modal--discount`);

    if (feedbackModal) {
        const feedbackModalContent = feedbackModal.innerHTML;

        triggerButtons.forEach((button) => {
            button.addEventListener(`click`, (evt) => {
                evt.preventDefault();

                Swal.fire({
                    customClass: {
                        container: `modal modal--discount`,
                        htmlContainer: `feedback-modal`,
                        popup: `modal__popup`,
                    },
                    html: feedbackModalContent,
                    showCloseButton: true,
                    showConfirmButton: false,
                    returnFocus: false,
                });

                const feedbackModalSweetAlert = document.querySelector(`.modal--discount`);

                if (feedbackModalSweetAlert) {
                    const formFields = feedbackModalSweetAlert.querySelectorAll(`.form__field`);
                    formFields.forEach((field) => {
                        window.form.initLabel(field);
                    });

                    const form = feedbackModalSweetAlert.querySelector(`.feedback-modal__form`);
                    form?.addEventListener(`submit`, (evt) => {
                        evt.preventDefault();

                        if (!lockForm(form)) return;
                        feedbackModalSweetAlert.classList.add(`modal--pending`);

                        let formData = new FormData(form);

                        fetch('/local/ajax/form.discount.php', {
                            method: 'POST',
                            body: formData
                        })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                }
                                return response.json();
                            })
                            .then((result) => {
                                if (!result.success) {
                                    throw new Error(result.message);
                                }
                                feedbackModalSweetAlert.classList.remove(`modal--pending`);
                                feedbackModalSweetAlert.classList.add(`modal--response-success`);
                                unlockForm(form);

                                let discountBanner = button.closest('.js-cta-bottom-block');
                                if (discountBanner) {
                                    discountBanner.remove();
                                }
                                document.cookie = `hide_discount_popup=Y; Max-Age=${60 * 60 * 24}; path=/; SameSite=Lax`;
                            })
                            .catch((error) => {
                                feedbackModalSweetAlert.classList.remove(`modal--pending`);
                                alert(error.message);
                                unlockForm(form);
                            });

                    });
                }
            });
        });
    }
})();

// Sign in modal
(function () {
    const triggerButtons = document.querySelectorAll(`.js-sign-in-button`);
    const feedbackModal = document.querySelector(`.feedback-modal--sign-in`);

    if (feedbackModal) {
        const feedbackModalContent = feedbackModal.innerHTML;

        triggerButtons.forEach((button) => {
            button.addEventListener(`click`, (evt) => {
                evt.preventDefault();

                Swal.fire({
                    customClass: {
                        container: `modal modal--sign-in`,
                        htmlContainer: `feedback-modal`,
                        popup: `modal__popup`,
                    },
                    html: feedbackModalContent,
                    showCloseButton: true,
                    showConfirmButton: false,
                    returnFocus: false,
                });

                const feedbackModalSweetAlert = document.querySelector(`.modal--sign-in`);

                if (feedbackModalSweetAlert) {
                    const phoneInput = feedbackModalSweetAlert.querySelector(`.form__input--phone`);
                    const phoneMask = window.form.setPhoneMask(phoneInput);

                    const formFields = feedbackModalSweetAlert.querySelectorAll(`.form__field`);
                    formFields.forEach((field) => {
                        window.form.initLabel(field);
                    });

                    let formStep = 'getCode';

                    const form = feedbackModalSweetAlert.querySelector(`.feedback-modal__form`);
                    form?.addEventListener(`submit`, (evt) => {
                        evt.preventDefault();

                        if (formStep === 'getCode' && phoneMask.unmaskedValue.length !== 11) {
                            return;
                        }

                        let otpValueInput = form.querySelector("#otp-value");
                        if (formStep === 'checkCode' && (!otpValueInput || otpValueInput.value.length !== 4)) {
                            return;
                        }

                        if (!lockForm(form)) return;
                        feedbackModalSweetAlert.classList.add(`modal--pending`);

                        let formData = new FormData();
                        formData.set('phone', `+${phoneMask.unmaskedValue}`);

                        if (formStep === 'checkCode') {
                            formData.set('code', otpValueInput.value);
                            formData.set('code_formatted', 'y');
                            formData.set('next', null);
                        }

                        let formAction = formStep === 'getCode' ? '/local/ajax/form.login.php' : '/local/ajax/form.sms-code.php';

                        fetch(formAction, {
                            method: 'POST',
                            body: formData
                        })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                }
                                return response.json();
                            })
                            .then((result) => {
                                if (result.error) {
                                    throw new Error(result.error);
                                }

                                feedbackModalSweetAlert.classList.remove(`modal--pending`);
                                unlockForm(form);

                                if (formStep === 'getCode') {
                                    feedbackModalSweetAlert.classList.add(`modal--response-success`);

                                    // next step state
                                    formStep = 'checkCode';
                                    phoneInput.disabled = true;
                                    phoneInput.readOnly = true;

                                    const codeInput = feedbackModalSweetAlert.querySelector(`#otp-input`);
                                    window.otpInput.init(codeInput, form);
                                }
                                else {
                                    if (result.action === "redirect") {
                                        location.href = result.url;
                                    } else {
                                        location.reload();
                                    }
                                }
                            })
                            .catch((error) => {
                                feedbackModalSweetAlert.classList.remove(`modal--pending`);
                                alert(error.message);
                                unlockForm(form);
                            });
                    });
                }
            });
        });
    }
})();

// Content modal
(function () {
    const triggerButtons = document.querySelectorAll(`.js-open-content-modal`);
    let mediaModalContent;

    triggerButtons.forEach((button) => {
        button.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            const mediaType = button.dataset.mediaType;
            const mediaSrc = button.dataset.mediaSrc;

            if (mediaType === `image`) {
                mediaModalContent = document.createElement(`img`);
                mediaModalContent.setAttribute(`src`, `${mediaSrc}`);
                mediaModalContent.setAttribute(`alt`, ``);
                mediaModalContent.setAttribute(`class`, `modal__image`);
            }
            if (mediaType === `video`) {
                mediaModalContent = document.createElement(`video`);
                mediaModalContent.setAttribute(`src`, `${mediaSrc}`);
                mediaModalContent.setAttribute(`class`, `modal__video`);
                mediaModalContent.setAttribute(`autoplay`, ``);
                mediaModalContent.setAttribute(`controls`, ``);
            }

            Swal.fire({
                customClass: {
                    container: `modal modal--media`,
                    popup: `modal__popup`,
                },
                html: mediaModalContent,
                showCloseButton: true,
                showConfirmButton: false,
                returnFocus: false,
            });
        });
    });
})();

// Feedback bottom
(function () {
    const feedbackBottom = document.querySelector(`.feedback__bottom`);
    const form = feedbackBottom?.querySelector(`.feedback__form`);

    form?.addEventListener(`submit`, (evt) => {
        evt.preventDefault();

        if (!lockForm(form)) return;
        feedbackBottom.classList.add(`feedback__bottom--pending`);

        let formData = new FormData(form);
        formData.set('name', formData.get('email'));

        fetch('/local/ajax/form.join.php', {
            method: 'POST',
            body: formData
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                if (!result.success) {
                    throw new Error(result.message);
                }
                feedbackBottom.classList.remove(`feedback__bottom--pending`);
                feedbackBottom.classList.add(`feedback__bottom--success`);
                unlockForm(form);
            })
            .catch((error) => {
                feedbackBottom.classList.remove(`feedback__bottom--pending`);
                alert(error.message);
                unlockForm(form);
            });
    });
})();

function lockForm(form) {

    if (form.classList.contains('js-processing')) {
        return false;
    }

    form.classList.add('js-processing');
    return true;
}

function unlockForm(form) {
    form.classList.remove('js-processing');
}